import { combineReducers } from "@reduxjs/toolkit";
import connection from "./connectionSlice";

const socketReducers = combineReducers({
	connection,
});

export default socketReducers;
